// import { PercentPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import dateFormat from 'dateformat';
import _ from 'lodash-es';
import * as pdf from 'pdfjs-dist';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import pdfMake, {
  Content,
  PageOrientation,
  Table,
  TableLayoutFunctions,
  TCreatedPdf,
  TDocumentDefinitions,
} from 'pdfmake/build/pdfmake';
import pdfFonts from '../../assets/fonts/vfs_fonts.js';
// import { UserCategory } from '../enums/user-category.enum';
import { Claim } from '../models/claim.model';
import { ClassificationItem } from '../models/classification-item.model';
import { ClassificationReport } from '../models/classification-report.model';
import { ClassificationResult } from '../models/classification-result.model';
import { Metadata } from 'pdfjs-dist/types/src/display/metadata.js';
// import { Metadata } from '../models/metadata.model';
import { Const } from '../static/const';
import { IconService } from './icon.service';
// import { AuthService } from './auth.service';
// import { I18nService } from './i18n.service';
// import { IconService } from './icon.service';

//

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private iconService: IconService) {
    // private percentPipe: PercentPipe // private iconService: IconService, // private authService: AuthService // private i18nService: I18nService,
    // pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    pdf.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
      UnileverShilling: {
        normal: 'UnileverShilling.ttf',
        bold: 'UnileverShillingBold.ttf',
        italics: 'UnileverShillingItalic.ttf',
      },
      UnileverShillingMedium: {
        normal: 'UnileverShillingMedium.ttf',
      },
    };
  }

  private async generateReport(
    classificationReport: any
  ): Promise<TCreatedPdf> {
    console.log('report', classificationReport);
    const totalColors = this.getTotalColors(classificationReport);
    const content: Array<string | Content> = [
      await this.getTitle(classificationReport),
      this.getOriginal(classificationReport),
      this.getMetadata(classificationReport.metadata),
      {
        table: {
          widths: [
            '4%',
            '15%',
            '3%',
            '7%',
            '4%',
            '5%',
            '6%',
            '9%',
            '5%',
            '8%',
            '15%',
            '5%',
            '14%',
          ],
          headerRows: 1,
          body: await this.getReportBody(classificationReport),
          dontBreakRows: true,
        },
        layout: {
          hLineWidth(i: number, node: { table: Table }) {
            if (i === 0) {
              return 0;
            }
            return i === node.table.body.length ? 2 : 1;
          },
          vLineWidth(i: number, node: { table: Table }) {
            return i === 0 || i === node.table.widths.length ? 0 : 1;
          },
          hLineColor(i: number, node: { table: Table }) {
            return '#9D9D9D';
          },
          vLineColor(i: number, node: { table: Table }) {
            return '#9D9D9D';
          },
          paddingLeft(i: number, node: { table: Table }) {
            return 5;
          },
          paddingRight(i: number, node: { table: Table }) {
            return i === node.table.widths.length - 1 ? 0 : 5;
          },
          paddingTop(i: number, node: { table: Table }) {
            return 10;
          },
          paddingBottom(i: number, node: { table: Table }) {
            return 10;
          },
          fillColor(i: number, node: any) {
            if (i === node.table.body.length - 1) {
              return totalColors?.background;
            } else {
              return false;
            }
          },
        } as TableLayoutFunctions,
        style: 'table',
      } as Content,
    ];
    if (classificationReport.disclaimers.length) {
      content.push({
        table: {
          widths: ['100%'],
          headerRows: 1,
          body: await this.getDisclaimers(classificationReport),
        },
        layout: {
          hLineWidth(i: number, node: { table: Table }) {
            return i === 1 ? 1 : 0;
          },
          vLineWidth(i: number, node: { table: Table }) {
            return 0;
          },
          hLineColor(i: number, node: { table: Table }) {
            return '#9D9D9D';
          },
          vLineColor(i: number, node: { table: Table }) {
            return '#9D9D9D';
          },
          paddingLeft(i: number, node: { table: Table }) {
            return 5;
          },
          paddingRight(i: number, node: { table: Table }) {
            return 5;
          },
          paddingTop(i: number, node: { table: Table }) {
            return 10;
          },
          paddingBottom(i: number, node: { table: Table }) {
            return 10;
          },
        } as TableLayoutFunctions,
        style: 'table',
      } as Content);
    }
    const docDefinition: TDocumentDefinitions = {
      info: {
        title: 'Risk Assessment Report',
        creator: 'Risk Assessment Tool',
        producer: 'Risk Assessment Tool',
      } as any,
      content,
      footer: this.getFooter.bind(this),
      pageOrientation: 'landscape' as PageOrientation,
      defaultStyle: {
        font: 'UnileverShilling',
        fontSize: 10,
        color: '#3F4347',
      },
      styles: {
        title: {
          font: 'UnileverShillingMedium',
          fontSize: 20,
          color: '#9D9D9D',
        },
        projectName: {
          font: 'UnileverShillingMedium',
          fontSize: 14,
          margin: [0, 23, 0, 0],
        },
        metadataName: {
          font: 'UnileverShillingMedium',
          fontSize: 8,
          color: '#9D9D9D',
        },
        table: {
          margin: [0, 23, 0, 0],
        },
        tableHeader: {
          font: 'UnileverShillingMedium',
          fontSize: 8,
        },
        total: {
          font: 'UnileverShillingMedium',
          fontSize: 12,
          color: totalColors?.text,
          fillColor: totalColors?.background,
        },
        totalReason: {
          fontSize: 10,
        },
      },
    };
    return pdfMake.createPdf(docDefinition);
  }

  private getTotalColors(report: any) {
    const total = report.results[report.total];
    const levelValue = total.level.manualTag || total.level;
    return Const.reportTotalColors[+levelValue];
  }

  async getReportFile(report: ClassificationReport): Promise<File> {
    return new Promise<File>(async (resolve) => {
      (await this.generateReport(report)).getBlob((blob) => {
        const file = new File([blob], this.getReportName(report));
        resolve(file);
      });
    });
  }

  public async saveReport(classificationReport: ClassificationReport) {
    const pdf = await this.generateReport(classificationReport);
    console.log('pdf', pdf);
    pdf.download(this.getReportName(classificationReport));
  }

  public getReportName(classificationReport: ClassificationReport) {
    const formattedDate = dateFormat(
      new Date(classificationReport.timestamp),
      Const.filenameDateFormat
    );
    return `Risk Assessment Report ${formattedDate}.pdf`;
  }

  private async getTitle(
    classificationReport: ClassificationReport
  ): Promise<string | Content | Array<string | Content>> {
    const logo = await this.iconService.getSvg(
      './assets/images/logos/logo-min.svg'
    );
    return {
      columns: [
        {
          width: 50,
          svg: logo,
        },
        {
          margin: [23, 0, 0, 0],
          stack: [
            {
              text: 'Risk Assessment Result',

              style: 'title',
            },
            'Created at ' +
              new Date(classificationReport.timestamp).toLocaleString('en-US'),
            {
              text: '',
              margin: [0, 30, 0, 0],
            },
          ],
        },
      ],
    };
  }

  // private getUserRoleAndCategory(): string {
  //   if (!this.authService.user) {
  //     return '';
  //   }
  //   const role = this.i18nService.translateInstant(
  //     `ENUMS.USER_ROLE.${this.authService.user.role}`
  //   );
  //   const category = this.getUserCategory(this.authService.user.category);
  //   return `${role}, ${category}`;
  // }

  // private getUserCategory(category: string) {
  //   if (category in UserCategory) {
  //     return `${category}`;
  //   }
  //   return category;
  // }

  private getOriginal(report: any): string | Content | Array<string | Content> {
    if (report.images?.length > 1) {
      const columns: Content[][] = [];
      for (let i = 0; i < report.images.length; i += 2) {
        const row: any = [];
        row.push({ image: report.images[i], fit: [350, 250] });
        if (i + 1 < report.images.length) {
          row.push({ image: report.images[i + 1], fit: [350, 250] });
        } else {
          row.push({ text: '' });
        }
        columns.push(row);
      }
      return [
        {
          text: 'Original Images',
          style: 'metadataName',
          margin: [0, 23, 10, 0],
        },
        {
          table: {
            widths: ['50%', '50%'],
            body: columns,
          },
          layout: 'noBorders',
        },
      ];
    }
    if (report.images?.length > 0) {
      return [
        {
          text: 'Original Images',
          style: 'metadataName',
          margin: [0, 23, 10, 0],
        },
        {
          image: report.images[0],
          fit: [800, 370],
          pageBreak: 'after',
        },
      ];
    }
    if (report.text?.length > 0) {
      return [
        {
          text: 'Original Text',
          style: 'metadataName',
          margin: [0, 23, 0, 0],
        },
        {
          text: report.text.split('!').join('\n'),
          margin: [0, 10, 0, 0],
        },
      ];
    }
    return {};
  }

  private getMetadata(metadata: any): Content {
    if (_.isEmpty(metadata)) {
      return {};
    }
    const content = [
      [
        {
          columns: [
            this.getMetadataColumn(metadata.project, 'PROJECT'),
            this.getMetadataColumn(metadata.product, 'PRODUCT'),
            this.getMetadataColumn(metadata.productFormat, 'PRODUCT FORMAT'),
          ],
          margin: [0, 10, 0, 10],
        },
        {
          columns: [this.getMetadataColumn(metadata.geography, 'GEOGRAPHY')],
          margin: [0, 0, 0, 10],
        },
      ],
    ];

    return content;
  }

  private getMetadataColumn(metadataValue: string | string[], name: string) {
    let valueStr = '-';
    if (metadataValue) {
      if (metadataValue instanceof Array) {
        valueStr = metadataValue.map((value) => `${value}`).join(', ');
      } else {
        valueStr = `${metadataValue}`;
      }
    }

    return [
      {
        text: `${name}`,
        style: 'metadataName',
      },
      valueStr,
    ];
  }

  private getFooter(
    currentPage: { toString: () => string },
    pageCount: string
  ) {
    return {
      text: 'Page ' + `${currentPage} of ${pageCount} `,

      alignment: 'center',
    };
  }

  private getReportTableHeader(): string | Content | Array<string | Content> {
    return [
      {
        text: 'Sl.No.',
        style: 'tableHeader',
      },
      {
        text: 'Image/Text',
        style: 'tableHeader',
      },
      {
        text: 'Page No.',
        style: 'tableHeader',
      },
      {
        text: 'Label',
        style: 'tableHeader',
      },
      {
        text: 'Level',
        style: 'tableHeader',
      },
      {
        text: 'Rules/Model Score',
        style: 'tableHeader',
      },
      {
        text: 'Manual Level',
        style: 'tableHeader',
      },
      {
        text: 'Risk',
        style: 'tableHeader',
      },
      {
        text: 'Rules/Model Score',
        style: 'tableHeader',
      },
      {
        text: 'Manual Risk',
        style: 'tableHeader',
      },
      {
        text: 'Reason',
        style: 'tableHeader',
      },
      {
        text: 'Rules/Model Score',
        style: 'tableHeader',
      },
      {
        text: 'Manual Reason',
        style: 'tableHeader',
      },
    ];
  }

  private async getReportBody(
    report: ClassificationReport
  ): Promise<Array<string | Content>> {
    const body = [this.getReportTableHeader()];
    for (let i = 0; i < report.results.length; i++) {
      const result: any = report.results[i];
      if ((result as any).isDeleted) {
        continue;
      }
      body.push([
        i + 1,
        this.getTextColumn(result),
        this.getPageNo(result.page_no),
        result.image != 'NULL' ? this.convertToTitleCase(result.Label) : 'Text',
        this.getLevelColumn(result),
        this.getMethodOrConfidence(result.level_model),
        this.getManualLevelColumn(result),
        await this.getRiskColumn(result),
        this.getMethodOrConfidence(result.risk_model),
        await this.getManualRiskColumn(result),
        this.getReasonColumn(result),
        this.getReasonModelColumn(result),
        this.getManualReasonColumn(result),
      ]);
    }

    body.push(await this.getTotalRow(report));
    return body;
  }

  private async getTotalRow(report: any): Promise<Content> {
    const total = report.results[report.total];
    const totalColors = this.getTotalColors(report);
    const res: Array<string | Content> = [];
    res.push({});

    res.push({
      text: 'Overall',
      style: 'total',
      width: '30%',
    });
    res.push({});
    res.push({});
    const levelValue = total.level.manualTag || total.level;
    res.push({ text: levelValue, style: 'total', width: '20%' });
    res.push({});
    res.push({});
    if (+levelValue === 2) {
      const riskValue = total.risk.manualTag || total.risk;
      let risk;
      if (riskValue == '1') {
        risk = 'Low';
      } else if (riskValue == '2') {
        risk = 'Medium';
      } else if (riskValue == '3') {
        risk = 'High';
      } else {
        risk = '';
      }
      res.push({ text: risk, style: 'total', width: '20%' });
    } else {
      res.push({});
    }
    res.push({});
    res.push({});
    const reasons: any = [];

    total.reason.forEach((item) => {
      if (item != '0') {
        if (item.manualTag === Const.deletedReason) {
          return;
        }

        reasons.push({
          text: this.getReasonName(item?.manualTag || item),
          style: ['total', 'totalReason'],
          width: '30%',
        });
      }
    });

    if (reasons.length > 0) {
      reasons[reasons.length - 1].margin = undefined;
    }
    res.push(reasons);
    res.push({});
    res.push({});
    return res;
  }

  private getPageNo(index) {
    const fileType = localStorage.getItem('fileType');
    if (fileType != null && fileType == 'application/pdf') {
      return index + 1;
    } else {
      return '-';
    }
  }

  private convertToTitleCase(label) {
    return label
      .toLowerCase()
      .split(' ')
      .map((s) => {
        let letterToCapitalize = s.match(/\w/)[0];
        return s.replace(letterToCapitalize, letterToCapitalize.toUpperCase());
      })
      .join(' ');
  }

  private getTextColumn(
    claim: Claim,
    isQualifier?: boolean
  ): string | Content | Array<string | Content> {
    console.log('claims', claim);
    console.log('isQualifier', isQualifier);
    if (isQualifier) {
      return claim;
    } else {
      if (claim?.text == 'NULL') {
        return {
          image: 'data:image/png;base64,' + claim?.image,
          fit: [400, 50],
        };
      } else {
        return claim.text;
      }
    }
  }

  private getMethodOrConfidence(item: any): Content {
    if (item?.manualTag) {
      // if (item.manualTag === item.prediction) {
      //   return {
      //     width: 50,
      //     alignment: 'right',
      //     text: 'approved',
      //   };
      // }
      return {
        width: 50,
        alignment: 'right',
        text: 'manual',
      };
    }
    if (item?.rule) {
      return {
        width: 50,
        alignment: 'right',
        text: 'by rules',
      };
    }
    return {
      width: 50,
      alignment: 'right',
      text: item != 'By Rules' ? this.getConfidence(item) : item,
    };
  }

  private getReasonMethodOrConfidence(item: any): Content {
    if (item?.manualTag) {
      // if (item.manualTag === item.prediction) {
      //   return {
      //     width: 50,
      //     alignment: 'right',
      //     text: 'approved',
      //   };
      // }
      return {
        width: 50,
        alignment: 'right',
        text: 'manual',
      };
    }
    if (item?.rule) {
      return {
        width: 50,
        alignment: 'right',
        text: 'by rules',
      };
    }
    return {
      width: 50,
      alignment: 'right',
      text:
        item != 'By Rules'
          ? item.map((resp) => {
              return this.getConfidence(resp);
            })
          : item,
    };
  }

  private getLevelColumn(
    result: any
  ): string | Content | Array<string | Content> {
    if (result.level == null || result.level == ' ') {
      return 0;
    }
    return {
      columns: [{ text: result.level.manualTag || result.level }],
    };
  }

  private getManualLevelColumn(
    result: any
  ): string | Content | Array<string | Content> {
    console.log('result', result);
    if (result.manual_level == null) {
      return '';
    }
    return {
      columns: [
        {
          text: result.manual_level.manualTag || result.manual_level,
        },
      ],
    };
  }

  private async getRiskColumn(result: any): Promise<string | Content> {
    if (result.risk == ' ') {
      return ' ';
    }
    let riskValue;
    if ((result.risk || result.risk.manualTag) == '1') {
      riskValue = 'Low';
    } else if ((result.risk || result.risk.manualTag) == '2') {
      riskValue = 'Medium';
    } else if ((result.risk || result.risk.manualTag) == '3') {
      riskValue = 'High';
    } else {
      riskValue = '';
    }
    return {
      columns: [
        { text: riskValue },
        result.risk_keywords.length == 0 && result.level != '2'
          ? this.getMethodOrConfidence(result.risk_model)
          : '',
      ],
    };
  }

  private async getManualRiskColumn(result: any): Promise<string | Content> {
    if (result.manual_risk == ' ') {
      return ' ';
    }
    let riskValue;
    if ((result.manual_risk || result.manual_risk.manualTag) == '1') {
      riskValue = 'Low';
    } else if ((result.manual_risk || result.manual_risk.manualTag) == '2') {
      riskValue = 'Medium';
    } else if ((result.manual_risk || result.manual_risk.manualTag) == '3') {
      riskValue = 'High';
    } else {
      riskValue = result.manual_risk;
    }
    return {
      columns: [{ text: riskValue }],
    };
  }

  private async getStarIndicator(
    count: number,
    total: number,
    color?: string
  ): Promise<Content> {
    // let starIcon = await this.iconService.getSvg(
    //   './assets/img/icons/star-icon.svg'
    // );
    const disabledIconPath = `./assets/img/icons/star-icon-${
      color ? 'abris' : 'disabled'
    }.svg`;
    // const starIconDisabled = await this.iconService.getSvg(disabledIconPath);
    // if (color) {
    //   starIcon = starIcon.replace(/fill="#3F4347"/g, `fill="${color}"`);
    // }
    const height = color ? 16 : 13;
    const columns: any = [];
    // for (let i = 0; i < total; i++) {
    //   const svg = i < count ? starIcon : starIconDisabled;
    //   columns.push({ svg, height });
    // }
    return { columns };
  }

  private getReasonColumn(
    result: any
  ): string | Content | Array<string | Content> {
    if (result.reason == null) {
      return '';
    }

    const content: any = [];
    let confidence;
    const reasonValues: any = [];
    const reasonData: any = [];

    if (result.reason.includes('0')) {
      for (let i = 0; i < result.reason.length; i++) {
        if (result.reason_keywords.length == 0) {
          // to push model value and reason value to single array
          reasonValues.push({
            reason: result.reason[i],
          });
        }
      }

      //to remove reason having '0' value
      reasonValues.forEach((v) => {
        if (v.reason != '0') {
          reasonData.push(v);
        }
      });

      reasonData.forEach((index, item) => {
        if (index.manualTag === Const.deletedReason) {
          return;
        }

        content.push({
          columns: [
            {
              width: '*',
              text: this.getReasonName(index?.manualTag || index.reason),
            },
          ],
          margin: [0, 0, 0, 5],
        });
      });

      if (content.length > 0) {
        content[content.length - 1].margin = undefined;
      }

      return content;
    } else {
      result.reason.forEach((item) => {
        if (item.manualTag === Const.deletedReason) {
          return;
        }

        content.push({
          columns: [
            {
              width: '*',
              text: this.getReasonName(item?.manualTag || item),
            },
          ],
          margin: [0, 0, 0, 5],
        });
      });

      if (content.length > 0) {
        content[content.length - 1].margin = undefined;
      }
      return content;
    }
  }

  private getReasonModelColumn(
    result: any
  ): string | Content | Array<string | Content> {
    if (result.reason == null) {
      return '';
    }

    const content: any = [];
    let confidence;
    const reasonValues: any = [];
    const reasonData: any = [];

    if (result.reason_model != 'By Rules') {
      result.reason_model.forEach((item) => {
        content.push({
          columns: [
            {
              width: '*',
              text: this.getMethodOrConfidence(item),
            },
          ],
          margin: [0, 0, 0, 5],
        });
      });
    }
    if (content.length > 0) {
      content[content.length - 1].margin = undefined;
    }
    return content;
  }

  private getManualReasonColumn(
    result: any
  ): string | Content | Array<string | Content> {
    if (result.reason == null) {
      return '';
    }

    const content: any = [];
    let confidence;
    const reasonValues: any = [];
    const reasonData: any = [];

    if (result.manual_reason.includes('0')) {
      for (let i = 0; i < result.reason.length; i++) {
        if (result.reason_keywords.length == 0) {
          // to push model value and reason value to single array
          reasonValues.push({
            reason: result.reason[i],
          });
        }
      }

      //to remove reason having '0' value
      reasonValues.forEach((v) => {
        if (v.reason != '0') {
          reasonData.push(v);
        }
      });

      reasonData.forEach((index, item) => {
        if (index.manualTag === Const.deletedReason) {
          return;
        }

        content.push({
          columns: [
            {
              width: '*',
              text: this.getReasonName(index?.manualTag || index.reason),
            },
          ],
          margin: [0, 0, 0, 5],
        });
      });

      if (content.length > 0) {
        content[content.length - 1].margin = undefined;
      }

      return content;
    } else {
      result.manual_reason.forEach((item) => {
        if (item.manualTag === Const.deletedReason) {
          return;
        }
        content.push({
          columns: [
            {
              width: '*',
              text: this.getReasonName(item?.manualTag || item),
            },
          ],
          margin: [0, 0, 0, 5],
        });
      });

      if (content.length > 0) {
        content[content.length - 1].margin = undefined;
      }
      return content;
    }
  }

  private getConfidence(classificationItem: any): any {
    const confidenceValue: any = classificationItem;
    if (confidenceValue == null || confidenceValue == ' ') {
      return '';
    }
    if (confidenceValue < 0.1) {
      return '< 10%';
    } else {
      return (confidenceValue * 100).toFixed(2);
    }
  }

  private getReasonName(tag: string): string {
    return tag ? tag : '';
  }

  private async getDisclaimers(
    report: ClassificationReport
  ): Promise<Array<string | Content>> {
    const body: Array<string | Content> = [
      [
        {
          text: 'Qualifier',
          style: 'tableHeader',
        },
      ],
    ];
    console.log('report', report);
    report.disclaimers.forEach((disclaimer) => {
      body.push([this.getTextColumn(disclaimer, true)]);
    });

    return body;
  }
}
